
<div class="data-content">
    <mat-card appearance="outlined">  
        <mat-card-header>
            <mat-icon mat-card-avatar>{{options.icon}}</mat-icon>
            <mat-card-title>{{options.desc}}</mat-card-title>
        </mat-card-header>
        
        <mat-card-content>  
        
        <div class="content"> 
            <simple-datagrid entityName="Mktpkit" [parentRow]="data" [condition]="condition" compact="true"></simple-datagrid>            
        </div>
        </mat-card-content>
        <mat-card-actions>
            <div fxFlex></div>
            <button mat-raised-button color="primary"(click)="fechar()">Fechar</button>
          </mat-card-actions>
    </mat-card>
</div>